export const dte = {
	"GEN": [
		{
			value: "FACT",
			label: "Factura"
		},
		{
			value: "FCAM",
			label: "Factura Cambiaria"
		},
		{
			value: "FESP",
			label: "Factura Especial"
		},
		{
			value: "NABN",
			label: "Nota de Abono"
		},
		{
			value: "NDEB",
			label: "Nota de Debito"
		},
		{
			value: "NCRE",
			label: "Nota de Credito"
		},
		{
			value: "RANT",
			label: "Recibo de Anticipos"
		},
		{
			value: "RECI",
			label: "Recibo"
		},
	],
	"PEQ": [
		{
			value: "FPEQ",
			label: "Factura Pequeño Contribuyente"
		},
		{
			value: "FCAP",
			label: "Factura Cambiaria Pequeño Contribuyente"
		},
		{
			value: "FESP",
			label: "Factura Especial"
		},
		{
			value: "NABN",
			label: "Nota de Abono"
		}
	],
	"PEE": [
		{
			value: "FAPE",
			label: "Factura Pequeño Contribuyente Régimen Electrónico"
		},
		{
			value: "FCPE",
			label: "Factura Cambiaria Pequeño Contribuyente Régimen Electrónico"
		},
		{
			value: "FESP",
			label: "Factura Especial"
		},
		{
			value: "NABN",
			label: "Nota de Abono"
		}
	],
	"AGR": [
		{
			value: "FACA",
			label: "Factura Contribuyente Agropecuario"
		},
		{
			value: "FCCA",
			label: "Factura Cambiaria Contribuyente Agropecuario"
		},
		{
			value: "FESP",
			label: "Factura Especial"
		},
		{
			value: "NABN",
			label: "Nota de Abono"
		}
	],
	"AGE": [
		{
			value: "FAAE",
			label: "Factura Contribuyente Agropecuario Régimen Electrónico Especial"
		},
		{
			value: "FCAE",
			label: "Factura Cambiaria Contribuyente Agropecuario Régimen Electrónico Especial"
		},
		{
			value: "FESP",
			label: "Factura Especial"
		},
		{
			value: "NABN",
			label: "Nota de Abono"
		}
	],
	"EXE": [
		{
			value: "RDON",
			label: "Recibo de Donación"
		},
		{
			value: "RECI",
			label: "Recibo"
		},
	]
};

export const dte_names = {
    FACT: "Factura",
    FCAM: "Factura Cambiaria",
	FESP: "Factura Especial",
	NABN: "Nota de Abono",
	NDEB: "Nota de Debito",
	NCRE: "Nota de Credito",
	RANT: "Recibo de Anticipos",
	RECI: "Recibo",
    FPEQ: "Factura Pequeño Contribuyente",
	FCAP: "Factura Cambiaria Pequeño Contribuyente",
    FAPE: "Factura Pequeño Contribuyente Régimen Electrónico",
    FCPE: "Factura Cambiaria Pequeño Contribuyente Régimen Electrónico",
	FACA: "Factura Contribuyente Agropecuario",
    FCCA: "Factura Cambiaria Contribuyente Agropecuario",
	FAAE: "Factura Contribuyente Agropecuario Régimen Electrónico Especial",
	FCAE: "Factura Cambiaria Contribuyente Agropecuario Régimen Electrónico Especial",
    RDON: "Recibo de Donación"
};

export const taxesByDte = {
	"FACT": {
		"IVA": ["IVA", 1, 12, 100, "GTQ"],
		"IVA EXENTO": ["IVA", 2, 0, 100, "GTQ"],
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
		"CERVEZA": ["BEBIDAS ALCOHOLICAS", 1, 6, 100, "GTQ"],
		"VINO": ["BEBIDAS ALCOHOLICAS", 2, 7.5, 100, "GTQ"],
		"SIDRA": ["BEBIDAS ALCOHOLICAS", 5, 8.5, 100, "GTQ"],
		"TABACO CONSUMIDOR": ["TABACO", 2, 75, 100, "GTQ"],
		"CEMENTO": ["CEMENTO", 1, 1.5, 1],
		"BEBIDAS GASEOSAS Y JARABES": ["BEBIDAS NO ALCOHOLICAS", 1, 0.18, 1, "GTQ"],
		"BEBIDAS ISOTONICAS O DEPORTIVAS": ["BEBIDAS NO ALCOHOLICAS", 2, 0.21, 1, "GTQ"],
		"JUGOS Y NECTARES": ["BEBIDAS NO ALCOHOLICAS", 3, 0.1, 1, "GTQ"],
		"BEBIDAS DE YOGUR": ["BEBIDAS NO ALCOHOLICAS", 4, 0.1, 1, "GTQ"],
		"AGUA NATURAL": ["BEBIDAS NO ALCOHOLICAS", 5, 0.08, 1, "GTQ"],
		"TARIFA PORTUARIA": ["TARIFA PORTUARIA", 1, 0.05, 1, "USD"]
	},
	"FCAM": {
		"IVA": ["IVA", 1, 12, 100, "GTQ"],
		"IVA EXENTO": ["IVA", 2, 0, 100, "GTQ"],
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
		"CERVEZA": ["BEBIDAS ALCOHOLICAS", 1, 6, 100, "GTQ"],
		"VINO": ["BEBIDAS ALCOHOLICAS", 2, 7.5, 100, "GTQ"],
		"SIDRA": ["BEBIDAS ALCOHOLICAS", 5, 8.5, 100, "GTQ"],
		"TABACO CONSUMIDOR": ["TABACO", 2, 75, 100, "GTQ"],
		"CEMENTO": ["CEMENTO", 1, 1.5, 1],
		"BEBIDAS GASEOSAS Y JARABES": ["BEBIDAS NO ALCOHOLICAS", 1, 0.18, 1, "GTQ"],
		"BEBIDAS ISOTONICAS O DEPORTIVAS": ["BEBIDAS NO ALCOHOLICAS", 2, 0.21, 1, "GTQ"],
		"JUGOS Y NECTARES": ["BEBIDAS NO ALCOHOLICAS", 3, 0.1, 1, "GTQ"],
		"BEBIDAS DE YOGUR": ["BEBIDAS NO ALCOHOLICAS", 4, 0.1, 1, "GTQ"],
		"AGUA NATURAL": ["BEBIDAS NO ALCOHOLICAS", 5, 0.08, 1, "GTQ"],
		"TARIFA PORTUARIA": ["TARIFA PORTUARIA", 1, 0.05, 1, "USD"]
	},
	"FPEQ": {
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"]
	},
	"FCAP": {
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"]
	},
	"FESP": {
		"IVA": ["IVA", 1, 12, 100, "GTQ"],
		"IVA EXENTO": ["IVA", 2, 0, 100, "GTQ"],
	},
	"NABN":{},
	"RDON":{},
	"RECI":{},
	"NDEB":{
		"IVA": ["IVA", 1, 12, 100, "GTQ"],
		"IVA EXENTO": ["IVA", 2, 0, 100, "GTQ"],
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
		"CERVEZA": ["BEBIDAS ALCOHOLICAS", 1, 6, 100, "GTQ"],
		"VINO": ["BEBIDAS ALCOHOLICAS", 2, 7.5, 100, "GTQ"],
		"SIDRA": ["BEBIDAS ALCOHOLICAS", 5, 8.5, 100, "GTQ"],
		"TABACO CONSUMIDOR": ["TABACO", 2, 75, 100, "GTQ"],
		"CEMENTO": ["CEMENTO", 1, 1.5, 1],
		"BEBIDAS GASEOSAS Y JARABES": ["BEBIDAS NO ALCOHOLICAS", 1, 0.18, 1, "GTQ"],
		"BEBIDAS ISOTONICAS O DEPORTIVAS": ["BEBIDAS NO ALCOHOLICAS", 2, 0.21, 1, "GTQ"],
		"JUGOS Y NECTARES": ["BEBIDAS NO ALCOHOLICAS", 3, 0.1, 1, "GTQ"],
		"BEBIDAS DE YOGUR": ["BEBIDAS NO ALCOHOLICAS", 4, 0.1, 1, "GTQ"],
		"AGUA NATURAL": ["BEBIDAS NO ALCOHOLICAS", 5, 0.08, 1, "GTQ"],
	},
	"NCRE":{
		"IVA": ["IVA", 1, 12, 100, "GTQ"],
		"IVA EXENTO": ["IVA", 2, 0, 100, "GTQ"],
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
		"CERVEZA": ["BEBIDAS ALCOHOLICAS", 1, 6, 100, "GTQ"],
		"VINO": ["BEBIDAS ALCOHOLICAS", 2, 7.5, 100, "GTQ"],
		"SIDRA": ["BEBIDAS ALCOHOLICAS", 5, 8.5, 100, "GTQ"],
		"TABACO CONSUMIDOR": ["TABACO", 2, 75, 100, "GTQ"],
		"CEMENTO": ["CEMENTO", 1, 1.5, 1],
		"BEBIDAS GASEOSAS Y JARABES": ["BEBIDAS NO ALCOHOLICAS", 1, 0.18, 1, "GTQ"],
		"BEBIDAS ISOTONICAS O DEPORTIVAS": ["BEBIDAS NO ALCOHOLICAS", 2, 0.21, 1, "GTQ"],
		"JUGOS Y NECTARES": ["BEBIDAS NO ALCOHOLICAS", 3, 0.1, 1, "GTQ"],
		"BEBIDAS DE YOGUR": ["BEBIDAS NO ALCOHOLICAS", 4, 0.1, 1, "GTQ"],
		"AGUA NATURAL": ["BEBIDAS NO ALCOHOLICAS", 5, 0.08, 1, "GTQ"],
	},
	"FACA":{},
	"FCCA":{},
	"FAPE":{
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
	},
	"FCPE":{
		"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
		"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
		"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
		"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
		"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
		"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
		"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
		"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
		"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
		"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
	},
	"FAAE":{},
	"FCAE":{},
	"RANT":{},
	"" : {}
};

export const dteNoIVA = [ "FPEQ", "FCAP", "NABN", "RDON", "RECI", "FACA", "FCCA", "FAPE", "FCPE", "FAAE", "FCAE", "RANT", "" ];


export const taxesResolution = {
	"IVA": ["IVA", 1, 12, 100, "GTQ"],
	"IVA EXENTO": ["IVA", 2, 0, 100, "GTQ"],
	"PETROLEO SUPER": ["PETROLEO", 1, 4.7, 1, "GTQ"],
	"PETROLEO REGULAR": ["PETROLEO", 2, 4.6, 1, "GTQ"],
	"PETROLEO DIESEL": ["PETROLEO", 4, 1.3, 1, "GTQ"],
	"TURISMO HOSPEDAJE": ["TURISMO HOSPEDAJE", 1, 10, 100, "GTQ"],
	"TURISMO HOSPEDAJE EXENTO": ["TURISMO HOSPEDAJE", 2, 0, 1, "GTQ"],
	"TURISMO PASAJES AEREO": ["TURISMO PASAJES", 1, 30, 1, "USD"],
	"TURISMO PASAJES MARITIMO": ["TURISMO PASAJES", 2, 10, 1, "USD"],
	"TURISMO PASAJES EXENTO": ["TURISMO PASAJES", 3, 0, 1, "USD"],
	"TIMBRE DE PRENSA": ["TIMBRE DE PRENSA", 1, 0.5, 100, "GTQ"],
	"BOMBEROS": ["BOMBEROS", 1, 2, 100, "GTQ"],
	"CERVEZA": ["BEBIDAS ALCOHOLICAS", 1, 6, 100, "GTQ"],
	"VINO": ["BEBIDAS ALCOHOLICAS", 2, 7.5, 100, "GTQ"],
	"SIDRA": ["BEBIDAS ALCOHOLICAS", 5, 8.5, 100, "GTQ"],
	"TABACO CONSUMIDOR": ["TABACO", 2, 75, 100, "GTQ"],
	"CEMENTO": ["CEMENTO", 1, 1.5, 1],
	"BEBIDAS GASEOSAS Y JARABES": ["BEBIDAS NO ALCOHOLICAS", 1, 0.18, 1, "GTQ"],
	"BEBIDAS ISOTONICAS O DEPORTIVAS": ["BEBIDAS NO ALCOHOLICAS", 2, 0.21, 1, "GTQ"],
	"JUGOS Y NECTARES": ["BEBIDAS NO ALCOHOLICAS", 3, 0.1, 1, "GTQ"],
	"BEBIDAS DE YOGUR": ["BEBIDAS NO ALCOHOLICAS", 4, 0.1, 1, "GTQ"],
	"AGUA NATURAL": ["BEBIDAS NO ALCOHOLICAS", 5, 0.08, 1, "GTQ"],
	"TARIFA PORTUARIA": ["TARIFA PORTUARIA", 1, 0.05, 1, "USD"]
};

export const satFrases = {
	"1": {
		"1": "Sujeto a pagos trimestrales ISR",
		"2": "Sujeto a retención definitiva ISR",
		"3": "Sujeto a pago directo ISR"
	},
	"2": {
		"1": "Agente de Retención del IVA"
	},
	"3": {
		"1": "No genera derecho a crédito fiscal"
	},
	"4": {
		"1": "Exenta del IVA (art. 7 num. 2 Ley del IVA)",
		"2": "Exenta del IVA (art. 7 num. 4 Ley del IVA)",
		"3": "Exenta del IVA (art. 7 num. 5 Ley del IVA)",
		"4": "Exenta del IVA (art. 7 num. 9 Ley del IVA)",
		"5": "Exenta del IVA (art. 7 num. 10 Ley del IVA)",
		"6": "Exenta del IVA (art. 7 num. 13 Ley del IVA)",
		"7": "Exenta del IVA (art. 7 num. 14 Ley del IVA)",
		"8": "Exenta del IVA (art. 8 num. 1 Ley del IVA)",
		"9": "Exenta del IVA (art. 7 num. 15 Ley del IVA)",
		"10": "Esta factura no incluye IVA (art. 55 Ley del IVA)",
		"11": "No afecta al IVA (Decreto 29-89 Ley de Maquila)",
		"12": "No afecta al IVA (Decreto 65-89 Ley de Zonas Francas)",
		"13": "Exenta del IVA (art. 7 num. 12, Ley del IVA)",
		"14": "Exenta del IVA (art. 7 num. 6 Ley del IVA)",
		"15": "Exenta del IVA (art. 7 num. 11 Ley del IVA)",
		"16": "Exenta del IVA (art. 8 num. 2 Ley del IVA)",
		"17": "Exenta del IVA (art. 32 literal c, Ley Orgánica Zolic)",
		"18": "(Contribuyentes con disposiciones específicas de exención al IVA)",
		"19": "Exenta del IVA (art. 3 num. 7 Ley del IVA)",
		"20": "Aportes (art. 35 Ley de Fortalecimiento al Emprendimiento)",
		"21": "Cargos e impuestos no sujetos a IVA (Aerolíneas)",
		"22": "Factura origen no incluye IVA",
		"23": "Exenta del IVA (art. 7, numeral 3, literal c, Ley del IVA)",
		"24": "No afecto al IVA (Fuera del hecho generador art. 3, 7 y 8, Ley del IVA)",
		"25": "Exenta del IVA (art. 31 Dec. 22-73 Ley Orgánica Zolic)",
		"26": "Exenta del IVA (art. 4 Dec. 31-2022 Ley de Fom. del Trab. Temp. en el Extranjero)",
		"27": "Exenta del IVA (art. 7 literal “a” Dec. 40-2022 Ley Inc. Mov. Eléctrica)",
		"28": "Exenta del IVA (art. 7 literal “c” Dec. 40-2022 Ley Inc. Mov. Eléctrica)",
		"29": "Exenta del IVA (art. 7 literal “d” Dec. 40-2022 Ley Inc. Mov. Eléctrica)",
		"30": "Exenta del IVA (art. 7 literal “g” Dec. 40-2022 Ley Inc. Mov. Eléctrica)",
		"31": "Exenta del IVA (art. 7 literal “h” o “i” Dec. 40- 2022 Ley Inc. Mov. Eléctrica)"
	},
	"5": {
		"1": "El vendedor o prestador del servicio se negó a emitir la factura correspondiente. (art. 52 Ley del IVA)"
	},
	"6": {
		"1": "Con forma de pago sobre las ventas brutas",
		"2": "Con forma de pago sobre las utilidades, no retener"
	},
	"7": {
		"1": "No retener",
		"2": "No retener"
	},
	"8": {
		"1": "Exenta del ISR (art. 8 núm. 2 Ley de Actualización Tributaria)",
		"2": "Exenta del ISR (art. 8 núm. 3 Ley de Actualización Tributaria)",
		"3": "Exenta del ISR (art. 8 núm. 5 Ley de Actualización Tributaria)",
		"4": "Exenta del ISR (art. 11 núm. 1 Ley de Actualización Tributaria)",
		"5": "Exenta del ISR (art. 11 núm. 2 Ley de Actualización Tributaria)",
		"6": "Exenta del ISR (art. 31 Ley Orgánica Zolic)",
		"7": "Exenta del ISR (art. 32 litar a, Ley Orgánica Zolic)",
		"8": "Exenta del ISR (art. 8 núm. 1 Ley de Actualización Tributaria)",
		"9": "Exenta del ISR (Art. 4, literal b), numeral ii, Dec. 40-2022, Ley Inc. Mov. Eléctrica)",
		"10": "Exenta del ISR (Art. 7, literal f, Dec. 40-2022, Ley Inc. Mov. Eléctrica)",
		"11": "Exenta del ISR (Art. 7, literal g, Dec. 40-2022, Ley Inc. Mov. Eléctrica)"
	},
	"9": {
		"1": "Esta factura incluye apoyo social temporal al precio del gas licuado envasado en cilindros portátiles",
		"2": "Esta factura incluye apoyo social temporal Decreto 42-2022",
		"3": "Monto total a pagar sin apoyo social GTQ - XXX",
		"4": "Exenta Impuesto Salida Vía Aérea (art. 4 Dec. 31-2022 Ley de Fom. del Trab. Temp. en el Extranjero)",
		"5": "Esta factura incluye apoyo social temporal al precio del gas licuado envasado en cilindros portátiles",
		"6": "Esta factura incluye apoyo social temporal Decreto 42-2022"
	}
};

export const satTipos = {
	"1": "Frases de retención del ISR",
	"2": "Frases de Agente de Retención del IVA",
	"3": "Frase de no genera derecho a crédito fiscal del IVA",
	"4": "Frases de exento o no afecto al IVA",
	"5": "Frases Factura Especial",
	"6": "Frases de Régimen Especial de contribuyente agropecuario",
	"7": "Frases de regímenes electrónicos ",
	"8": "Frases de Exento de ISR",
	"9": "Frases Especiales"
};

export const ivaRegimenExento = ["EXE"];

const dteType1 = [
	"FACT", "FCAM", "NCRE", "NDEB"
];

const dteType2 = [
	"FACT", "FCAM", "NCRE", "NDEB"
];

const dteType3 = [
	"FPEQ", "FCAP", "FAPE", "FCPE", "FACA", "FCCA", "FAAE", "FCAE"
];

const ivaRegimentType3 = [
	"PEQ", "PEE", "AGR", "AGE"
];

const dteType4Obl = [
	"RDON", "RECI"
]; 
const dteType4Opt = [
	"FACT", "FCAM", "FESP", "NCRE", "NDEB"
]; 

const dteType5 = [
	"FESP"
];

const dteType6 = [
	"FACA", "FCCA"
];

const dteType7 = [
	"FAPE", "FCPE", "FAAE", "FCAE"
];

const dteType8 = [
	"FACT", "FCAM", "RDON", "RECI", "NCRE", "NDEB"
];

const dteType9 = [
	"FACT", "FCAM", "FPEQ", "FCAP", "NCRE", "NDEB", "FAPE", "FCPE"
];


export const getDefaultFrases = (companyTaxAuthoritySpecifications, dtetype) => {
	const frases = [];
	if (dteType1.includes(dtetype)) {
		if (companyTaxAuthoritySpecifications.isr_regimen === "RSUAL") {
			frases.push({type:"1", scenario:"1"});
		} else if (companyTaxAuthoritySpecifications.isr_regimen === "ROSIAL") {
			frases.push({type:"1", scenario:"2"});
		}
	}
	if (dteType3.includes(dtetype)) {
		if (ivaRegimentType3.includes(companyTaxAuthoritySpecifications.iva_regimen)) {
			frases.push({type:"3", scenario:"1"});
		}
	}    
	if (dteType7.includes(dtetype)) {
		if (companyTaxAuthoritySpecifications.iva_regimen == "PEE") {
			frases.push({type:"7", scenario:"1"});
		}
		else if (companyTaxAuthoritySpecifications.iva_regimen == "AGE") {
			frases.push({type:"7", scenario:"2"});
		}
	}
	return frases;
};

export const getSelectDefaultFrases = (companyTaxAuthoritySpecifications, dtetype) => {
	const frases = [];
	if (dteType4Obl.includes(dtetype)) {
		for (let scenario = 1; scenario <= 31; scenario++) {
			frases.push({ type: "4", scenario: String(scenario) });
		}
	}
	if (dteType6.includes(dtetype)) {
		frases.push({type:"6", scenario:"1"});
		frases.push({type:"6", scenario:"2"});
	}
	return frases;
};

export const getOptionalFrases = (companyTaxAuthoritySpecifications, dtetype) => {
	const frases = [];
    
	if (dteType2.includes(dtetype)) {
		if (companyTaxAuthoritySpecifications.agente_retenedor_iva) {
			frases.push({type:"2", scenario:"1"});
		}
	}
	if (dteType4Opt.includes(dtetype)) {
		for (let scenario = 1; scenario <= 31; scenario++) {
			frases.push({ type: "4", scenario: String(scenario) });
		}
	}
	if (dteType5.includes(dtetype)) {
		frases.push({ type: "5", scenario: "1" });
	}
	if (dteType8.includes(dtetype)) {
		for (let scenario = 1; scenario <= 11; scenario++) {
			frases.push({ type: "8", scenario: String(scenario) });
		}
	}
	if (dteType9.includes(dtetype)) {
		for (let scenario = 1; scenario <= 6; scenario++) {
			frases.push({ type: "8", scenario: String(scenario) });
		}
	}
	return frases;
};
